module.exports = __webpack_public_path__ + "static/Wix-44bcfa1b14b4d21fb8eb1234623abccf.png";